import { t } from 'i18next';

export default function getStatusColor(status) {
  switch (status) {
    case t('status.draft'):
    case 'draft':
      // case 'Draft':
      // console.log("draft", status, ">>>>")
      return 'status status--draft';
    case t('status.open'):
    case 'open':
    case t('status.confirmed'):
    case 'confirmed':
      return 'status status--confirmed';
    case t('status.active'):
    case 'active':
      return 'status status--shipped';
    case t('status.inactive'):
      return 'status status--draft';
    case t('status.closed'):
    case 'closed':
      return 'status status--closed';
    case 'onhold':
    case t('status.onhold'):
      // case 'Onhold':
      return 'status status--onhold';
    case t('Items.received'):
    case 'received':
      return 'status status--received';
    case t('status.receiving'):
    case 'receiving':
      return 'status status--receiving';
    case t('status.cancelled'):
    case 'cancelled':
      return 'status status--cancelled';
    case t('status.partially received'):
    case 'partially received':
      return 'status status--partially-received';
    case t('status.issued'):
    case 'issued':
      return 'status status--issued';
    case t('status.complete'):

    case 'complete':
      // case 'Complete':
      return 'status status--complete';
    case t('status.unpaid'):

    case 'unpaid':
      // case 'Unpaid':
      return 'status status--unpaid';
    case t('status.paid'):

    case 'paid':
      // case 'Paid':
      return 'status status--paid';
    case t('status.partially_paid'):

    case 'partially paid':
      // case 'Partially paid':
      return 'status status--partially-paid';
    case t('status.part_paid'):
    case t('partially applied'):
      // case 'PRTL Paid':
      return 'status status--partially-paid';
    case t('status.overdue'):

    case 'overdue':
      // case 'Overdue':
      return 'status status--overdue';
    case t('status.not_shipped'):

    case 'not shipped':
      return 'status status--not-shipped';
    case t('status.delivered'):

    case 'delivered':
      return 'status status--delivered';
    case t('status.shipped'):

    case 'shipped':
      return 'status status--shipped';
    case t('status.void'):

    case 'void':
      return 'status status--void';
    case t('status.sent'):

    case 'sent':
      // case 'Sent':

      return 'status status--sent';
    case t('status.consumed'):

    case 'consumed':
      // case 'Consumed':

      return 'status status--paid';
    case t('status.partially_applied'):
      // case 'partially applied':
      return 'status status--partially-paid';
    default:
      return 'status';
  }
}
